import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UAVStatus } from 'src/app/model/UAVStatus';
import { GenericAkitaHTTPService, HttpOptions } from '../../service/generic-akita-http.service';
import { NetworkService } from '../../service/network.service';

@Injectable({
  providedIn: 'root'
})
export class AkitaUAVHttpService extends GenericAkitaHTTPService<UAVStatus> {
  constructor(http: HttpClient, networkService: NetworkService) {

    const options: HttpOptions = {
      params: {
        type: 'UAVStatus',
        options: 'keyValues',
        orderBy: 'dateCreated',
        limit: '100'
      }
    };
    super(http, networkService, '/v2/entities/', 'uavstatus', options);
  }
}
